import { reactive } from 'vue';

/**
 * Global loading flags behind the corner <loader> in App.vue.
 * The root component's data() RETURNS this object, so views keep the old
 * `this.$root.loading = true` contract, while router hooks (no component
 * instance available there) import and toggle it directly — replacing the
 * `router.app.$options` access that vue-router 4 removed.
 */
export default reactive({ loading: false, errorLoading: false });
